/* Holzhof Rheinsberg - eigene Ergaenzungen
   Links auf die Hauptwebsite in neuem Tab oeffnen.
   Shopify-Menuepunkte kennen keine "target"-Einstellung, daher hier.
   rel="noopener noreferrer" ist Pflicht: ohne das kann die geoeffnete Seite
   ueber window.opener auf die Ursprungsseite zugreifen. */
(function () {
  function externeLinks() {
    var links = document.querySelectorAll('a[href*="holzhofrheinsberg.com"]');
    for (var i = 0; i < links.length; i++) {
      var a = links[i];
      if (a.hostname && a.hostname.indexOf('shop.') === 0) continue;   // eigener Shop bleibt im Tab
      a.setAttribute('target', '_blank');
      a.setAttribute('rel', 'noopener noreferrer');
    }
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', externeLinks);
  } else {
    externeLinks();
  }
  /* Nachladende Bereiche wie den Warenkorb ebenfalls abdecken */
  if (window.MutationObserver) {
    new MutationObserver(externeLinks).observe(document.documentElement, {childList: true, subtree: true});
  }
})();
